import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Progress } from './ui/progress';
import { Badge } from './ui/badge';
import EmbeddedModule from './EmbeddedModule';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuditFortress = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/audit-fortress/checklist`)
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  const totalOpen = data?.stages.reduce((a, s) => a + s.open, 0) || 0;
  const totalItems = data?.stages.reduce((a, s) => a + s.items, 0) || 0;
  const avg = data
    ? Math.round(data.stages.reduce((a, s) => a + s.progress, 0) / data.stages.length)
    : 0;

  return (
    <EmbeddedModule
      eyebrow="RBI Pre-Audit Readiness"
      title="Audit Fortress"
      tagline="Tier-1 RBI readiness pack — cybersecurity, IT outsourcing, master directions, evidence vault and mock-audit walk-throughs. Built for ₹1.5 Cr-grade engagements."
      badgeText="Tier-1 Infrastructure"
      accentClass="from-indigo-700 via-indigo-600 to-blue-700"
      embedUrl="https://fortress-india.replit.app"
      embedTitle="fortress-india.replit.app"
      testId="audit-fortress-page"
      kpis={[
        { label: 'Overall Readiness', value: `${avg}%` },
        { label: 'Open Items', value: totalOpen, hint: `${totalItems} total` },
        { label: 'Stages', value: data?.stages.length || 6 },
        { label: 'Pack Value', value: '₹1.5 Cr' }
      ]}
    >
      <Card data-testid="audit-fortress-checklist">
        <CardHeader>
          <CardTitle>Readiness Stages</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {data?.stages.map((s, idx) => (
              <div key={idx} className="space-y-1.5">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2 min-w-0">
                    <span className="text-sm font-medium text-gray-900 truncate">{s.name}</span>
                    <Badge variant="outline" className="text-[10px]">{s.items} items</Badge>
                    {s.open > 0 && (
                      <Badge className="bg-amber-100 text-amber-800 text-[10px]">{s.open} open</Badge>
                    )}
                  </div>
                  <span className="text-xs text-gray-500 font-mono">{s.progress}%</span>
                </div>
                <Progress value={s.progress} className="h-2" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </EmbeddedModule>
  );
};

export default AuditFortress;
